<div class="gravatar" [ngStyle]="gravatarStyles">
    <img [src]="source" [attr.width]="size" [attr.height]="size"
    />
</div>